export const userDetailReducer = (state, action) => {
  switch (action.type) {
    case 'EDIT_FORM': {
      return {
        ...state,
        [action.name]: action.value,
        [`${action.name}Error`]: false,
        saveError: false
      }
    }
    case 'SET_ERRORS': {
      const { fields } = action
      fields.forEach(f => {
        state[f] = true
      })
      return { ...state }
    }
    default: {
      return state
    }
  }
}


export const editAddressReducer = (state, action) => {
  switch (action.type) {
    case 'EDIT_FORM': {
      return {
        ...state,
        [action.name]: action.value,
        typeError: false,
        saveError: false
      }
    }
    case 'SET_LOCATION': {
      return {
        ...state,
        location: action.location,
        locationError: false,
        saveError: false
      }
    }
    case 'SET_ERRORS': {
      const { fields } = action
      fields.forEach(f => {
        state[f] = true
      })
      return { ...state }
    }
    default: {
      return state
    }
  }
}
